import React, { useState, useEffect } from 'react';
import { Modal, Tabs, Button } from 'antd';
import { ShoppingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ItemSelector from './ItemSelector';
import { Item } from '../../../types/item';

interface ItemListManagerProps {
  visible: boolean;
  onClose: () => void;
  whiteListItems: Item[];
  blackListItems: Item[];
  onWhiteListChange: (items: Item[]) => void;
  onBlackListChange: (items: Item[]) => void;
  mainDivision?: string;
  categoryIds?: string[];
  currentListType?: "white" | "black";
}

const ItemListManager: React.FC<ItemListManagerProps> = ({
  visible,
  onClose,
  whiteListItems,
  blackListItems,
  onWhiteListChange,
  onBlackListChange,
  mainDivision,
  categoryIds,
  currentListType = 'white'
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(currentListType);

  // 当弹框打开或currentListType改变时，更新activeTab
  useEffect(() => {
    if (visible) {
      setActiveTab(currentListType);
    }
  }, [visible, currentListType]);

  // 处理保存
  const handleSave = () => {
    onClose();
  };

  return (
    <Modal
      title={t('hqDisplayGroup.itemManagement.itemSelector.title')}
      open={visible}
      width={900}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t('hqDisplayGroup.cancel')}
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          {t('hqDisplayGroup.save')}
        </Button>,
      ]}
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'white',
            label: (
              <span>
                <ShoppingOutlined />
                {t('hqDisplayGroup.itemManagement.whitelistManagement')}
              </span>
            ),
            children: (
              <ItemSelector
                selectedItems={whiteListItems}
                onItemsChange={onWhiteListChange}
                title={t('hqDisplayGroup.whiteListItems')}
                currentListType={"white"}
                mainDivision={undefined}
                categoryIds={undefined}
                visible={visible}
              />
            ),
          },
          {
            key: 'black',
            label: (
              <span>
                <ShoppingOutlined />
                {t('hqDisplayGroup.itemManagement.blacklistManagement')}
              </span>
            ),
            children: (
              <ItemSelector
                selectedItems={blackListItems}
                onItemsChange={onBlackListChange}
                title={t('hqDisplayGroup.blackListItems')}
                currentListType={"black"}
                mainDivision={mainDivision}
                categoryIds={categoryIds}
                visible={visible}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
};

export default ItemListManager;